import { Component, OnInit } from '@angular/core';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { BirthdayService } from 'src/app/services//birthday.service';
import { GroupService } from 'src/app/services/group.service';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CustomReportExportComponent } from 'src/app/components/extract-custom-report/custom-report-export.component';
import { MessageUtil } from 'src/app/utils/message.util';

@Component({
  selector: 'app-customer-birthday',
  templateUrl: './customer-birthday.component.html',
  styleUrls: ['./customer-birthday.component.scss'],
  providers: [BirthdayService, GroupService, MessageService],
})
export class CustomerBirthdayComponent implements OnInit {
    birthdays: any[] = new Array();
    dateRange: Date[];
    minBirthdayDate: Date;
    maxBirthdayDate: Date;
    filters: any = {
      active: 1,
      groupName: '',
      gender: '',
      name: '',
      minAge: 0,
      maxAge: 150
    };

    public groupOptions: Array<{ label: string, value: any }> = [
      { label: 'Todos os Grupos', value: '' }
    ];

    public active: Array<{ label: string, value: any }> = [
      { label: 'Ativo', value: 1 },
      { label: 'Inativo', value: 0 },
      { label: 'Ambos', value: '' }
    ];

    public genderOptions: Array<{ label: string, value: any }> = [
      { label: 'Ambos', value: '' },
      { label: 'Masculino', value: 'M' },
      { label: 'Feminino', value: 'F' }
    ];

    public ageOptions: Array<{ label: string, value: number }> = [];

    constructor(
      private spinner: NgxSpinnerService,
      private birthdayService: BirthdayService,
      private groupService: GroupService,
      private messageService: MessageService,
      public dialog: DialogService,
      private messageUtil: MessageUtil
    ){

    }

    ngOnInit():void{
      this.setYearBoundaries();
      this.initializeDateRange();
      this.loadGroups();
      this.initializeAgeOptions();
    }

    initializeDateRange():void {
      this.dateRange = [new Date(this.minBirthdayDate), new Date(this.maxBirthdayDate)];
    }

    setYearBoundaries(): void {
      const currentYear = new Date().getFullYear();
      this.minBirthdayDate = new Date(currentYear, 0, 1);
      this.maxBirthdayDate = new Date(currentYear, 11, 31);
    }

    initializeAgeOptions(): void {
      this.ageOptions = [];
      for (let i = 0; i <= 150; i++) {
        this.ageOptions.push({ label: i.toString(), value: i });
      }
    }

    loadGroups():void {
      this.groupService.findAllActive().subscribe(
        (groups) => {
          this.groupOptions = [
            { label: 'Todos os Grupos', value: '' },
            ...groups
              .filter(group => group.active)
              .map(group => ({ label: group.name, value: group.name }))
              .sort((a, b) => a.label.localeCompare(b.label))
          ];
          this.getCustomerBirthday();
        },
        (error) => {
          console.error('Erro ao carregar grupos:', error);
          this.getCustomerBirthday();
        }
      );
    }

    exportTable(): void {
      if (!this.birthdays || this.birthdays.length === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Não há dados para exportar'
        });
        return;
      }

      const data = { table: this.birthdays, type: 'CUSTOMER_BIRTHDAY' };
      this.dialog.open(CustomReportExportComponent, {
        width: '70%',
        height: '90vh',
        dismissableMask: false,
        data,
        header: 'Exportar Relatório de Aniversariantes',
      });
    }

    getCustomerBirthday():void {
      if (!this.dateRange || this.dateRange.length !== 2 || !this.dateRange[0] || !this.dateRange[1]) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Atenção',
          detail: 'Por favor, selecione um período completo (data inicial e data final) para realizar a pesquisa.'
        });
        return;
      }

      if (this.spinner) {
        this.spinner.show();
      }

      const sanitizedFilters = this.getSanitizedFilters();
      
      this.birthdayService.newCallBirthdayEndpoint(sanitizedFilters).subscribe(response=>{
        this.birthdays = this.sortBirthdaysByMonthAndDay(response);
        if (this.spinner) {
          this.spinner.hide();
        }
      }, error => {
        console.error('Erro ao buscar aniversariantes:', error);
        if (this.spinner) {
          this.spinner.hide();
        }
      });
    }

    getSanitizedFilters():any{
      this.normalizeDateRangeYear();
      const sanitized = { ...this.filters };
      
      if (this.dateRange && this.dateRange.length === 2) {
        sanitized.startDate = this.dateRange[0];
        sanitized.endDate = this.dateRange[1];
      }
      
      Object.keys(sanitized).forEach((key) => {
        if("" === sanitized[key]) {
          sanitized[key] = undefined;
        }
      });
      
      return sanitized;
    }

    clearFilters():void{
      this.filters = {
        active: 1,
        groupName: '',
        gender: '',
        name: '',
        minAge: 0,
        maxAge: 150
      };
      this.initializeDateRange();
      this.getCustomerBirthday();
    }

    calcAge(birthDate: Date):any {
      const age = moment().diff(birthDate, 'years');
      return  Number.isNaN(age) ? '' : age;
    }

    translateGender(gender: string): string {
      switch(gender){
        case "M":
          return "Masculino";
        case "F":
          return "Feminino";
        default:
          return "";
      }
    }

    sortBirthdaysByMonthAndDay(birthdays: any[]): any[] {
      if (!birthdays || birthdays.length === 0) {
        return birthdays;
      }

      return birthdays.sort((a, b) => {
        const dateA = new Date(a.birthday);
        const dateB = new Date(b.birthday);
        
        const monthA = dateA.getMonth();
        const monthB = dateB.getMonth();
        
        if (monthA !== monthB) {
          return monthA - monthB;
        }
        
        const dayA = dateA.getDate();
        const dayB = dateB.getDate();
        
        if (dayA !== dayB) {
          return dayA - dayB;
        }
        
        const yearA = dateA.getFullYear();
        const yearB = dateB.getFullYear();
        
        return yearA - yearB;
      });
    }

    normalizeDateRangeYear(): void {
      if (!this.dateRange || this.dateRange.length !== 2) {
        return;
      }

      const currentYear = this.minBirthdayDate?.getFullYear() ?? new Date().getFullYear();
      this.dateRange = this.dateRange.map(date => {
        if (!date) {
          return date;
        }
        const normalized = new Date(date);
        normalized.setFullYear(currentYear);
        return normalized;
      }) as Date[];
    }
}

